















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
export default class SingleEpisodeCard extends Vue {
  @Prop() episode!: any;
  @Prop() index!: any;
  Categories: any;
  currentRoute: any;
  episodeId = 1;
  get currentRouteName() {
    return this.$route.name;
  }
  DeleteConversation(id: any, index: any) {
    const d = "";
  }
}
